import { sortParticipantsByVenueRole } from "sb-resp-utils";
export const mapTeamNames = (x) => {
    var participants = x.participants.slice().sort(sortParticipantsByVenueRole);
    const swapArray = x.isTeamSwap ? [1, 0] : [0, 1];
    x.team1name = participants[swapArray[0]].name;
    x.team2name = participants[swapArray[1]].name;
    return x;
};
//# sourceMappingURL=mapTeamNames.js.map